export default __webpack_public_path__ + "static/media/Talent_GlassCannon.b29feadb.png";